import { AdminLinkedPlaceProps } from './admin-linked-place-props';
import { AdminPlacePicker } from '../admin-place-picker';
import { ControlText } from '@mint/ui';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  border: 1px solid ${props => props.theme.palette.divider};
  border-radius: 4px;
  display: flex;
  margin: 2rem -0.5rem 0;
  padding: 0.5rem;
  align-items: center;
`;

const Title = styled(ControlText)`
  flex: 1;
`;

export const AdminLinkedPlace: React.FunctionComponent<
  AdminLinkedPlaceProps
> = ({ onPlaceSelect, name }) => {
  return (
    <Wrapper>
      <Title>{name ? name : <i>No Linked Place</i>}</Title>
      <AdminPlacePicker onPlaceSelect={onPlaceSelect} />
    </Wrapper>
  );
};
